/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const TypeChecking = {
    Alphabets: (data) => {
        const inputVal = data.value.toString();
        const onlyAlphabits = inputVal.replace(/[^a-zA-Z ]+/g, '');
        return onlyAlphabits;
    },
    Numeric: (data) => {
        const inputVal = data.value.toString();
        const onlyNumbers = inputVal.replace(/[^0-9]/g, '');
        return onlyNumbers;
    },
    NumbericHypen: (data) => {
        const inputVal = data.value.toString();
        const onlyNumbers = inputVal.replace(/[^0-9-]/g, '');
        return onlyNumbers;
    },
    Phone: (data) => {
        const inputVal = data.value.toString();
        const onlyNumbers = inputVal.replace(/[^0-9-+() ]/g, '');
        return onlyNumbers;
    },
    AlphaNumeric: (data) => {
        const inputVal = data.value.toString();
        const AlphaNumeric = inputVal.replace(/[^a-zA-Z0-9 ]/g, '');
        return AlphaNumeric;
    },
    AlphaNumericSpecial: (data) => {
        const inputVal = data.value.toString();
        const AlphaNumeric = inputVal.replace(/[^ A-Za-z0-9_@.,/#&+-/!/?":;'/(/)]*$/g, '');
        return AlphaNumeric;
    },
    AlphaNumericHypen: (data) => {
        const inputVal = data.value.toString();
        // Allow add alpha numeric with hypen. Ex: APPLE-20, 123-222-2, PAY-50
        const onlyAlphaNumericHypen = inputVal.replace(/[^a-zA-Z0-9-]/g, '');
        return onlyAlphaNumericHypen;
    },
    AlphaNumericGiftMessage: (data) => {
        const inputVal = data.value.toString();
        const AlphaNumeric = inputVal.replace(/[^ A-Za-z0-9_.,%/*()!?=&+-:;'"]*$/g, '');
        return AlphaNumeric;
    },
};

export default TypeChecking;
